export default __webpack_public_path__ + "static/media/hr.c57b640f.svg";